/* @flow */
import React from 'react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import to from 'to-case';

import { ComponentWithInjectedProps } from 'utils/injectedProps';
import Loading from 'components/Loading/Loading';

import styles from './RefreshIndicator.module.scss';

export type IndicatorState = 'stale' | 'refreshing' | 'up-to-date' | 'loading' | 'loading-filters';
export type RefreshIndicatorProps = {
  state: IndicatorState,
};

type InjectedProps = TranslatorProps;

@translate()
export default class RefreshIndicator extends ComponentWithInjectedProps<
  RefreshIndicatorProps,
  {},
  InjectedProps
> {
  renderStateLoading = () => {
    const { state } = this.props;

    switch (state) {
      case 'refreshing':
      case 'loading':
      case 'loading-filters':
        return (
          <Loading variant="small" style={{ marginLeft: -10, marginTop: -5, marginBottom: -5 }} />
        );

      case 'stale':
      case 'up-to-date':
      default:
        return;
    }
  };
  renderStateContent = () => {
    const { state, t } = this.props;

    return <span className={styles.text}>{t(`general:loading_states.${to.snake(state)}`)}</span>;
  };

  render() {
    return (
      <div className={styles.wrapper}>
        {this.renderStateLoading()}
        {this.renderStateContent()}
      </div>
    );
  }
}
